/* Vision Global lens-replacement page behaviors.
   JS-gated: without JS the page is fully visible and usable. */
document.documentElement.classList.add('js');

/* Scroll reveals */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
  document.querySelectorAll('.vg-lens .reveal').forEach(function (el) { io.observe(el); });
})();

/* #order anchor: on the product template the order point is the theme's
   main-product section (which hosts the LensAdvisor app block). Shopify
   generates that section's wrapper id, so plant a stable anchor before it. */
(function () {
  if (document.getElementById('order')) return;
  var main = document.querySelector('[id^="shopify-section-"][id$="__main"]');
  if (main) main.insertAdjacentHTML('beforebegin', '<span id="order" aria-hidden="true"></span>');
})();

/* Sticky order bar (mobile): visible only between the hero and the order point */
(function () {
  var bar = document.querySelector('.vg-lens .sticky-cta');
  var hero = document.querySelector('.vg-lens .hero');
  var order = document.getElementById('order');
  if (!bar || !hero || !order || !('IntersectionObserver' in window)) return;
  var pastHero = false, atClose = false;
  function update() { bar.classList.toggle('show', pastHero && !atClose); }
  new IntersectionObserver(function (es) {
    es.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
    update();
  }, { threshold: 0 }).observe(hero);
  new IntersectionObserver(function (es) {
    es.forEach(function (e) { atClose = e.isIntersecting; });
    update();
  }, { threshold: 0.15 }).observe(order);
})();

/* Reduced motion: stop autoplaying lab videos for users who ask for less
   motion. The clip still shows its first frame. */
(function () {
  if (!window.matchMedia || !matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.vg-lens video').forEach(function (v) {
    v.removeAttribute('autoplay');
    v.pause();
  });
})();

/* Path CTAs: open the LensAdvizor flow for the matching Frame Type variant.
   The buy box (main-product section) is disabled on this template, so the
   hero renders hidden quick-buy proxies instead (snippets/vg-lens-advisor);
   clicking one launches the app's modal for its variant. If the app hasn't
   loaded, fall back to the old behavior: preselect the variant in the buy
   box (when re-enabled) and let the #order anchor jump happen. */
(function () {
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('[data-frame]');
    if (!link) return;
    var want = link.getAttribute('data-frame').toLowerCase();

    /* LensAdvizorBase is the app's inline bootstrap; it only exists when the
       LensAdvisor app embed (or its buy-box app block) rendered on the page.
       Without it the widget is a non-functional stub, so fall through. */
    var proxy = document.querySelector('.vg-la-proxy [data-vg-frame="' + want + '"]');
    if (proxy && window.LensAdvizor && window.LensAdvizorBase) {
      ev.preventDefault();
      proxy.click();
      return;
    }

    var main = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if (!main) return;
    var inputs = main.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var val = (inputs[i].value || '').toLowerCase();
      if (val === want || val.indexOf(want) !== -1) {
        if (!inputs[i].checked) {
          inputs[i].click();
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
  });
})();

/* Frame qualifier: show the matching answer, one at a time */
(function () {
  var box = document.querySelector('.vg-lens .frame-check');
  if (!box) return;
  var buttons = box.querySelectorAll('.fc-btns button');
  var answers = box.querySelectorAll('.fc-answers p');
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      answers.forEach(function (a) { a.hidden = (a.id !== btn.getAttribute('data-a')); });
    });
  });
})();

/* "Chat with us" links: open Shopify Inbox chat (<shopify-chat>) instead of email.
   The link keeps a mailto: href, so it still works if the chat widget hasn't loaded. */
(function () {
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('[data-vg-chat]');
    if (!link) return;
    var chat = document.querySelector('shopify-chat');
    if (!chat) return; /* no chat widget on the page: let the mailto: fallback run */
    ev.preventDefault();
    /* The "Open chat" button only exists while the chat is closed or minimised.
       When the panel is already open there is nothing to press, so leave it open. */
    var btn = chat.shadowRoot && chat.shadowRoot.querySelector('button.activator');
    if (btn) btn.click();
  });
})();
